import { render, staticRenderFns } from "./newPromptPage.vue?vue&type=template&id=26238aac&scoped=true"
import script from "./newPromptPage.vue?vue&type=script&lang=js"
export * from "./newPromptPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26238aac",
  null
  
)

export default component.exports